import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { nativeEventBus } from '~/@common/services/nativeEventBus'

/**
 * 푸시 알림 클릭 시 네이티브가 보내는 navigateTo 이벤트를 처리한다.
 * 전체 URL을 앱 내부 경로(pathname + search + hash)로 변환하여 navigate.
 */
export const usePushNotificationNavigation = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const unsub = nativeEventBus.subscribe('navigateTo', (e) => {
      const targetUrl = e.detail?.url
      if (!targetUrl) return

      // 전체 URL → 앱 내부 경로로 변환
      try {
        const parsed = new URL(targetUrl)
        navigate(`${parsed.pathname}${parsed.search}${parsed.hash}`)
      } catch {
        // URL 파싱 실패 시 그대로 사용 (상대 경로 등)
        navigate(targetUrl)
      }
    })

    return unsub
  }, [navigate])
}
